/* eslint-disable @typescript-eslint/no-unused-vars */
import { OverseasPriceService } from "td_server/services";
import {
  setLoading,
  setPriceConversionRate,
  setIsCountryDisabled,
} from "./../slices/priceConversionSlice";
import { trackedAsync } from "../../utils/analyics/trackedAsync";
export const getPriceConversionRate =
  (location: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync( ()=> OverseasPriceService.getOverSeasPriceRate(
        location
      ));
      if (response?.isError === true) {
        dispatch(setIsCountryDisabled(response?.isCountryDisabled));
      } else {
        dispatch(setPriceConversionRate(response));
      }
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };
